// frontend/src/features/tbs/components/PreviewTable.jsx
// Center panel before a run starts: what the server made of the pasted list.
import React from "react";
import { CheckCircle2, AlertCircle, X } from "lucide-react";

export default function PreviewTable({ preview, collectorsByKey, onRemove }) {
  const rows = preview?.rows || [];
  return (
    <div className="tbs-card" style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      <div className="tbs-card-hd">
        <h2>Checked accounts</h2>
        <span className="sub">{rows.filter((r) => r.ok).length} of {rows.length} ready · nothing has been fetched yet</span>
      </div>
      <div className="tbs-tbl-wrap">
        <table className="tbs-tbl">
          <thead>
            <tr><th>#</th><th>Collector</th><th>Account</th><th>Year</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {rows.map((r, i) => {
              const c = r.collector ? collectorsByKey[r.collector] : null;
              return (
                <tr key={`${r.position}-${r.collector}-${r.account_raw}`}>
                  <td className="num">{i + 1}</td>
                  <td className="coll">{c ? c.name : (r.collector_raw || <span style={{ color: "#C75454" }}>?</span>)}</td>
                  <td className="acct">
                    {r.ok ? r.account : r.account_raw}
                    {r.ok && r.account !== r.account_raw && r.account_raw && <small>typed: {r.account_raw}</small>}
                  </td>
                  <td>{r.year || <span style={{ color: "#B8BFD0" }}>—</span>}</td>
                  <td>
                    {r.ok
                      ? <span className="tbs-pill ok"><CheckCircle2 size={11} /> ready</span>
                      : <span className="tbs-pill err" title={r.error}><AlertCircle size={11} /> {r.error}</span>}
                  </td>
                  <td className="right"><button className="tbs-icon-btn danger" onClick={() => onRemove(r)} title="Remove from this run"><X size={12} /></button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
